import { CardBackground, Typography } from "@hellocarbo/lasagne";
import { cn } from "@hellocarbo/lasagne/utils";
import { LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { TScenario } from "@/types";

type SimulationScenarioItemProps = {
  value: TScenario;
  Icon: LucideIcon;
  onChange: () => void;
};

function SimulationScenarioItem({
  value,
  Icon,
  onChange,
}: SimulationScenarioItemProps) {
  const { t } = useTranslation("simulation");

  return (
    <li className="h-full">
      <label className="h-full cursor-pointer">
        <CardBackground
          className={cn(
            "border-grayscale-xx-light h-full border text-center shadow-sm",
            "hover:border-grayscale-x-light focus-visible:border-grayscale-x-light hover:shadow-lg focus-visible:shadow-lg",
            "has-checked:border-secondary has-checked:bg-secondary-xx-light"
          )}
        >
          <input
            type="radio"
            name="scenario"
            value={value}
            className="appearance-none"
            onChange={onChange}
          />
          <Icon className="size-lg text-secondary justify-self-center" />
          <Typography as="h3" step="1" weight="bold" autoSpacing>
            {t(`simulation:scenarios.${value}.title`)}
          </Typography>
          <Typography className="text-grayscale">
            {t(`simulation:scenarios.${value}.description`)}
          </Typography>
        </CardBackground>
      </label>
    </li>
  );
}

export default SimulationScenarioItem;
